import _ from "lodash";
// put this right under the lodash import
const defaultSearchPayload = {
  selected_columns: [],
  isWildcard: true,
  title_search: '',
  selectedPeriod: 'consumptionperiod',
  start_date: '',
  end_date: '',
  pub_start_date: '',
  pub_end_date: '',
  page_nr: 1,
  publishedToDate: '',
  site_id: [],
  category_id: [],
  title_key_start: 0,
  start_value: '',
  columns: [],
  measures: [],
  title_keys: null,
  title_codes: [],
  GenreConfigs: [],
  consolidationPeriods: [],
  showPubDate: false,
  filters: {
    measured_days: { from: null, to: null },
    total_contacts: { from: null, to: null },
    total_online_rating: { from: null, to: null },
    title_length: { from: null, to: null },
    tv_rating: { from: null, to: null },
  },
};
export default {
  namespaced: true,
  org_columns: [],
  state: {
    type:"ProgramQueryModel",
    showAllRows: false,
    sort_by: '',
    sort_direction: 'ASC',
    excluded_rows:[],
    payload: _.cloneDeep(defaultSearchPayload),
    defaultPayload: _.cloneDeep(defaultSearchPayload),
    hasSetDefaultSearchPayload: false,
  },

  getters: {
    getSelectedPeriod: state => {
      return state.payload.selectedPeriod;
    }, 
    getStartDate: state => {
      return state.payload.start_date;
    },
    getPayload: state => {
      return state.payload
    },
    getDefaultPayload: state => { return state.defaultPayload },
  },

  mutations: {
    setDefaultSearchPayload(state, payload) {
      state.defaultPayload = _.cloneDeep(payload);
      state.hasSetDefaultSearchPayload = true;
    },
    updateShowAllRows(state, newShowAllRowsValue) {
      state.showAllRows = newShowAllRowsValue;
    },
    
    updateExcludedRows(state, rownr) {
      if (rownr && rownr.length) {
        state.excluded_rows = [...state.excluded_rows, ...rownr];
      } else {
        state.excluded_rows = [];
      }
    },
    updateIsWildcard(state, newIsWildcard) {
      state.payload.isWildcard = newIsWildcard;
    },
    updateTitleKeyStart(state, newTitleKeyStart) {
      state.payload.title_key_start = newTitleKeyStart;
    },
    updateStartValue(state, newStartValue) {
      state.payload.start_value = newStartValue;
    },
    updateSortBy(state, newSortBy) {
      state.sort_by = newSortBy;
    },
    updateSortDirection(state, newSortDirection) {

      state.sort_direction = newSortDirection;
    },
    updatePeriod(state, newSelectedPeriod) {
      state.payload.selectedPeriod = newSelectedPeriod;
    },
    updateTitleSearch(state, newTitleSeatch) {
      state.payload.title_search = newTitleSeatch;
    },
    updateStartDate(state, newStartDate) {  
      state.payload.start_date = newStartDate;
    },
    updateEndDate(state, newEndDate) {  
      state.payload.end_date = newEndDate;
    },
    updatePubStartDate(state, newPubStartDate) {
      state.payload.pub_start_date = newPubStartDate;
    },
    updatePubEndDate(state, newPubEndDate) {
      state.payload.pub_end_date = newPubEndDate;
    },
    updateSiteIds(state, newSiteIds) {
      state.payload.site_id = newSiteIds;
    },
    updateCategoryIds(state, newCategoryIds) {
      state.payload.category_id = newCategoryIds;
    },
    updateShowPubDate(state, newShowPubDate) {
      state.payload.showPubDate = newShowPubDate;
    },
    updateColumns(state, newColumns) {
      this.org_columns = newColumns;
      let requiredColumns = ['title_key', 'title_code', 'site_id', 'published_at'];

      //state.payload.columns = newColumns.concat(requiredColumns);
      // unika kolumner
      state.payload.columns = [...new Set([...newColumns, ...requiredColumns])];
      state.disableSearchButton = false;
    },
    updateSelectedColumns(state, newColumns) {
      state.payload.selected_columns = newColumns;
    },
    updateTitleLength(state, newTitleLength) {
      state.payload.filters.title_length = newTitleLength;
    },
    updateMeasuredDays(state, newMeasuredDays) {
      state.payload.filters.measured_days = newMeasuredDays;
    },
    updateTotalOnlineRating(state, newTotalOnlineRating) {
      state.payload.filters.total_online_rating = newTotalOnlineRating;
    },
    updateTvRating(state, newTvRating) {
      state.payload.filters.tv_rating = newTvRating;
    },
    updateTotalStarts(state, newTotalStarts) {  
      state.payload.filters.total_contacts = newTotalStarts;
    },
    updateMeasures(state, newMeasures) {
      state.payload.measures = newMeasures;
    },
    updateGenreConfigs(state, newConfigs) {
      state.payload.GenreConfigs = newConfigs;
    },
    updateConsolidationPeriods(state, newConsolidationPeriods) {
      state.payload.consolidationPeriods = newConsolidationPeriods;
    },
    updateRows_per_page(state, newRows_per_page) {
      state.payload.rows_per_page = newRows_per_page;
    },
    updatePublishedToDate(state, newPublishedToDate) {
      state.payload.publishedToDate = newPublishedToDate;
    },
    updatePayload(state, newPayload) {
      state.payload = newPayload;
    }
  },
};
